import { FaStar } from 'react-icons/fa';
import Slider from 'react-slick';
import smart_mentor from '../assets/smart_mentor.png';

const testimonials = [
  {
    name: 'Marvin L',
    rating: 5,
    video: smart_mentor,
    text: `Don I just want to thank you from the bottom of my heart for the help and the great calls daily.. I was at my last $80 when I found you about 4months ago and followed you..and now at $3K plus... thank you so much and im so happy to have found such a great group to be in and learn from..happy holidays from my family and I🙏🤝`,
  },
  {
    name: 'Barry B.',
    rating: 5,
    video: smart_mentor,
    text: `I just wanted to say thank you for the advice, was close to giving up and have completely turned my account around by following the stocks you keep reiterating`,
  },
];

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  autoplay: true,
  arrows: false,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const Testimonial = ({ variant = 'classic' } = {}) => {
  if (variant === 'v2') {
    return (
      <section className="relative overflow-hidden bg-white py-20 sm:py-28">
        <div className="pointer-events-none absolute left-1/2 top-0 h-[360px] w-[480px] -translate-x-1/2 rounded-full bg-[#6756FE]/10 blur-[110px]" />
        <div className="relative mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
          <div className="mx-auto max-w-2xl text-center">
            <p className="text-xs font-bold tracking-[0.3em] text-[#6756FE] uppercase">
              Testimonials
            </p>
            <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              Hear from our traders
            </h2>
            <p className="mt-3 text-slate-500">Real stories from members who follow the alerts and grow with the community.</p>
          </div>

          <div className="mt-12">
            <Slider {...settings}>
              {testimonials.map((item, idx) => (
                <div key={idx} className="px-1 sm:px-2">
                  <div className="mx-auto flex max-w-3xl flex-col overflow-hidden rounded-3xl border border-slate-200/80 bg-[#f8f7fc] shadow-xl shadow-slate-200/40 md:flex-row">
                    <div className="flex h-52 items-center justify-center bg-white md:h-auto md:w-2/5">
                      <img
                        src={item.video}
                        alt={`${item.name} testimonial`}
                        className="h-full w-full object-cover"
                      />
                    </div>
                    <div className="flex flex-1 flex-col justify-center p-6 sm:p-8">
                      <div className="mb-3 flex items-center justify-between gap-3">
                        <p className="font-bold text-[#6756FE]">{item.name}</p>
                        <div className="flex gap-0.5 text-amber-400">
                          {Array.from({ length: 5 }).map((_, i) => (
                            <FaStar
                              key={i}
                              className={`h-3.5 w-3.5 ${i < item.rating ? 'text-amber-400' : 'text-slate-300'}`}
                            />
                          ))}
                        </div>
                      </div>
                      <div className="max-h-40 overflow-y-auto pr-1">
                        <p className="text-sm leading-relaxed text-slate-600">{item.text}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="bg-white py-20 px-4 md:px-20">
      <div className="max-w-7xl mx-auto text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-black">
          Transformative Experiences
          <br />
          <span className="text-black">Hear from Our Traders</span>
        </h2>
      </div>

      <Slider {...settings}>
        {testimonials.map((item, idx) => (
          <div key={idx}>
            <div className="flex flex-col md:flex-row items-center justify-center w-full md:space-x-4">
              <div className="bg-[#f1f1f1] w-full max-w-md rounded-2xl h-[220px] flex items-center justify-center shadow">
                <img
                  src={item.video}
                  alt="Testimonial Video"
                  className="h-full object-cover rounded-2xl"
                />
              </div>
              <div className="bg-[#1a1a1a] text-white rounded-2xl p-6 w-full max-w-md shadow md:h-[220px] overflow ">
                <div className="flex items-center justify-between mb-2">
                  <p className="text-indigo-500 font-semibold">{item.name}</p>
                  <div className="flex gap-1 text-yellow-400">
                    {[1, 2, 3, 4, 5].map((_, i) => (
                      <span key={i}>
                        {i < item.rating ? (
                          <FaStar key={i} className="text-yellow-400" />
                        ) : (
                          <FaStar key={i} className="text-gray-400" />
                        )}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="max-h-60 md:max-h-60 overflow-y-auto pr-2 custom-scrollbar">
                  <p className="text-sm leading-relaxed text-gray-300">{item.text}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default Testimonial;
